<template>
    <div>
        <Header>


        </Header>

        <div class="page">
            <h2 v-t="'Page 404'"></h2>
            <p v-t="'The page, article or URL you were looking for couldn\'t be found, probably because it has been deleted. Please navigate back to the dashboard with the links in the left sidebar.'"></p>

        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'

    export default {
        components: {
            Header
        },
        data () {
            return {
            }
        }
    }
</script>